import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Select from "@material-ui/core/Select";
import compose from "recompose/compose";
import {connect} from "react-redux";

import {
	updEditableTableValue
} from "../../../../actions/components";
import MenuItem from "@material-ui/core/MenuItem";


const styles = {
	tableTextInput:{
		fontSize:'0.875rem',
		marginTop:2

	}
};

class dropDown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value : !props.hasBlank && !props.value ? props.defaultValue : props.value,
		};
	}
	handleOnChange = (event) =>{
		this.setState({
			value:event.target.value
		})
		const {dispatch, id, name} = this.props;
		dispatch(updEditableTableValue({
			id,
			name,
			value:event.target.value
		}))
	}


	render() {
		const {disabled, name, id, dataSource, hasBlank, defaultValue,classes} = this.props;
		const objectName = name + "_" + id;
		return (
			<Select
				value={this.state.value}
				onChange={this.handleOnChange}
				displayEmpty
				disabled={disabled}
				name={objectName}
				fullWidth
				className={classes.tableTextInput}

			>
				{hasBlank &&
				<MenuItem value={''} key={-1}>&nbsp;</MenuItem>
				}
				{dataSource.map((items,index)=>{
					return(
						<MenuItem value={items.value} key={index}>
							{items.name}
						</MenuItem>
					)
				})}
			</Select>
		);
	}
}

dropDown.propTypes = {
	value : PropTypes.string,
	dataSource : PropTypes.array,
	disabled : PropTypes.bool,
	hasBlank : PropTypes.bool,
	defaultValue : PropTypes.string,

	id : PropTypes.string.isRequired,
	name : PropTypes.string.isRequired

};
dropDown.defaultProps = {
	dataSource : [],
	disabled : false,
	hasBlank : true,
	defaultValue : ''
}
const mapStateToProps = state => {
	return {
		tableState : state.componentsEditableTableState,
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(dropDown);



// WEBPACK FOOTER //
// ./src/common/components/table/input/drop-down.js